import React, { useEffect, useState } from "react";
import { FaWifi } from "react-icons/fa";
import { RiComputerLine } from "react-icons/ri";
import { IoSnowSharp } from "react-icons/io5";
import { FaBath, FaPerson } from "react-icons/fa6";
import { API_BASE, IMG_BASE } from "../config";
function Booknow() {
  const [rooms, setRooms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [showModal, setShowModal] = useState(false);
  const [selectedRoom, setSelectedRoom] = useState(null);
  const [booking, setBooking] = useState({
    guest_name: "",
    email: "",
    phone: "",
    number_of_guests: 1,
    children: 0,
    room_id: null,
    check_in: "",
    check_out: "",
    special_requests: "",
    booking_status: "Pending",
    booking_source: "Website"
  });
  const [bookingLoading, setBookingLoading] = useState(false);
  const [bookingError, setBookingError] = useState(null);
  const [bookingSuccess, setBookingSuccess] = useState(false);

  useEffect(() => {
    const base = API_BASE;
    async function fetchRooms() {
      try {
        const res = await fetch(`${base}rooms`);
        if (!res.ok) throw new Error(`Failed to fetch rooms: ${res.status}`);
        const data = await res.json();
        setRooms(data);
      } catch (e) {
        setError(e.message || "Failed to fetch rooms");
      } finally {
        setLoading(false);
      }
    }
    fetchRooms();
  }, []);
 
  const imgBase = IMG_BASE;

  function openModal(room) {
    setSelectedRoom(room);
    setBooking((b) => ({ ...b, room_id: room.id }));
    setShowModal(true);
    setBookingError(null);
    setBookingSuccess(false);
  }

  function closeModal() {
    setShowModal(false);
    setSelectedRoom(null);
  }

  function handleBookingChange(e) {
    const { name, value } = e.target;
    setBooking((b) => ({ ...b, [name]: value }));
  }

  async function handleBookingSubmit(e) {
    e.preventDefault();
    setBookingLoading(true);
    setBookingError(null);

    const childrenCount = Number(booking.children) || 0;
    const specialReq = (booking.special_requests || "").trim();
    const specialRequests = childrenCount
      ? (specialReq ? `${specialReq} | Children: ${childrenCount}` : `Children: ${childrenCount}`)
      : specialReq;

    const payload = {
      // map explicit fields to the API payload shape you provided
      guest_name: booking.guest_name,
      email: booking.email,
      phone: booking.phone,
      number_of_guests: Number(booking.number_of_guests) || 1,
      room_id: booking.room_id,
      check_in: booking.check_in,
      check_out: booking.check_out,
      special_requests: specialRequests,
      booking_status: "Pending",
      booking_source: "Website",
      // include children count as well (optional, kept for backend)
      children: childrenCount
    };

    try {
      const res = await fetch(`${API_BASE}bookings`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });
      if (!res.ok) {
        const text = await res.text();
        throw new Error(`Booking failed: ${res.status} ${text}`);
      }
      const data = await res.json();
      setBookingSuccess(true);
      // Optionally clear or keep form
      setBooking({
        guest_name: "",
        email: "",
        phone: "",
        number_of_guests: 1,
        children: 0,
        room_id: null,
        check_in: "",
        check_out: "",
        special_requests: "",
        booking_status: "Pending",
        booking_source: "Website"
      });
      setTimeout(() => {
        setBookingSuccess(false);
        closeModal();
      }, 1200);
      console.log("Booking created:", data);
    } catch (err) {
      setBookingError(err.message || "Failed to create booking");
      console.error(err);
    } finally {
      setBookingLoading(false);
    }
  }

  return (
    <>
      <div
        className="container-fluid header-bg py-5 mb-5 wow fadeIn header_bg-bookNow"
        data-wow-delay="0.1s"
      >
        <div
          className="container py-5 d-flex justify-content-start"
          style={{ flexDirection: "column" }}
        >
          <h3
            className="display-4 text-white mb-3 animated slideInDown"
            style={{ fontSize: "40px" }}
          >
            Book now
          </h3>
          <nav aria-label="breadcrumb animated slideInDown">
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item">
                <a className="text-white" href="/">
                  Home
                </a>
              </li>
              <li
                className="breadcrumb-item text-primary active"
                aria-current="page"
              >
                Book now
              </li>
            </ol>
          </nav>
        </div>
      </div>

      <section className="spad3">
        <div className="container">
          <div className="row  d-flex justify-content-center">
            <div className="col-lg-10 col-xl-9 col-md-12">
              <div
                className="row book-main   justify-content-center"
                style={{ gap: "20px" }}
              >
                {loading && (
                  <div className="col-12">
                    <p>Loading rooms...</p>
                  </div>
                )}

                {error && (
                  <div className="col-12">
                    <p style={{ color: "red" }}>Error: {error}</p>
                  </div>
                )}

                {!loading &&
                  !error &&
                  rooms.length === 0 && (
                    <div className="col-12">
                      <p>No rooms available.</p>
                    </div>
                  )}

                {!loading &&
                  !error &&
                  rooms.map((room) => {
                    const image =
                      room.images && room.images.length
                        ? `${imgBase}images/rooms/${room.images[0]}`
                        : "img/room/room1.png";

                    const personIcons = [];
                    const capacity = Number(room.capacity) || 1;
                    const count = Math.max(1, capacity);
                    for (let i = 0; i < count; i++) {
                      personIcons.push(
                        <FaPerson
                          key={i}
                          style={{ color: "#3286b8" }}
                          size="25"
                        />
                      );
                    }

                    return (
                      <div
                        className="col-lg-10 col-xl-9 col-md-12 col-sm-8  justify-content-center  "
                        key={room.id}
                      >
                        <div className="row" style={{ border: "1px solid gray" }}>
                          <div className="col-lg-4 col-md-4 p-0">
                            <img src={image} alt={room.room_type} />
                          </div>

                          <div
                            className="col-lg-5 col-md-5 d-flex flex-column"
                            style={{ gap: "15px" }}
                          >
                            <a className="mt-3">
                              {room.room_type} {room.room_category}
                            </a>
                            <div className="d-flex" style={{ gap: "5px" }}>
                              {room.facilities?.includes("Wifi") && <FaWifi />}
                              {room.facilities?.includes("TV") && <RiComputerLine />}
                              {room.facilities?.includes("AC") && <IoSnowSharp />}
                              {room.facilities?.includes("Bath") && <FaBath />}
                            </div>
                          </div>

                          <div
                            className="col-lg-3 col-md-3 book-last-div  justify-content-center align-items-center w-100 d-flex flex-column"
                            style={{ gap: "10px" }}
                          >
                            <div className="d-flex mt-3">{personIcons}</div>
                            <h4>$ {room.price}</h4>
                            <p>per night</p>
                            <button
                              type="button"
                              className="details-btn btn"
                              onClick={() => openModal(room)}
                            >
                              Details
                            </button>
                          </div>
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
        </div>
      </section>

      {showModal && (
        <>
          <div className="modal show d-block" tabIndex="-1" role="dialog" aria-modal="true">
            <div className="modal-dialog modal-lg" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Book Room {selectedRoom?.room_number || ""}</h5>
                  <button type="button" className="btn-close" aria-label="Close" onClick={closeModal} />
                </div>
                <form onSubmit={handleBookingSubmit}>
                  <div className="modal-body">
                    {bookingError && <div className="alert alert-danger">{bookingError}</div>}
                    {bookingSuccess && <div className="alert alert-success">Booking created successfully</div>}

                    <div className="mb-3">
                      <label className="form-label">Guest Name</label>
                      <input name="guest_name" value={booking.guest_name} onChange={handleBookingChange} className="form-control" required />
                    </div>

                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Email</label>
                        <input type="email" name="email" value={booking.email} onChange={handleBookingChange} className="form-control" required />
                      </div>
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Phone</label>
                        <input name="phone" value={booking.phone} onChange={handleBookingChange} className="form-control" required />
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label className="form-label">No of Adults</label>
                        <input type="number" min="1" name="number_of_guests" value={booking.number_of_guests} onChange={handleBookingChange} className="form-control" />
                      </div>
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Children</label>
                        <input type="number" min="0" name="children" value={booking.children} onChange={handleBookingChange} className="form-control" />
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Check In</label>
                        <input type="date" name="check_in" value={booking.check_in} onChange={handleBookingChange} className="form-control" required />
                      </div>
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Check Out</label>
                        <input type="date" name="check_out" value={booking.check_out} onChange={handleBookingChange} className="form-control" required />
                      </div>
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Special Requests</label>
                      <textarea name="special_requests" value={booking.special_requests} onChange={handleBookingChange} className="form-control" rows="3" />
                    </div>

                    <input type="hidden" name="room_id" value={booking.room_id || ""} />
                    <input type="hidden" name="booking_status" value="Pending" />
                    <input type="hidden" name="booking_source" value="Website" />
                  </div>

                  <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" onClick={closeModal}>Close</button>
                    <button type="submit" className="btn btn-primary" disabled={bookingLoading}>
                      {bookingLoading ? "Booking..." : "Confirm Booking"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div className="modal-backdrop show"></div>
        </>
      )}
    </>
  );
}
 
export default Booknow;
